import type { ComponentProps } from "react"
import { cn } from "@/utilities"

export function AccountOrderDetailSkeleton({
  className,
  ...props
}: ComponentProps<"div">) {
  return (
    <section
      className={cn(
        "rounded-2xl border bg-white p-6 shadow-xs md:p-8",
        className
      )}
      {...props}
    >
      <div className='animate-pulse space-y-8'>
        {/* Header skeleton */}
        <div className='space-y-2'>
          <div className='h-6 w-3/4 rounded bg-muted' />
        </div>

        {/* Items table skeleton */}
        <div className='space-y-4'>
          <div className='h-7 w-48 rounded bg-muted' />
          <div className='space-y-3'>
            <div className='h-24 w-full rounded bg-muted' />
            <div className='h-24 w-full rounded bg-muted' />
            <div className='h-24 w-full rounded bg-muted' />
          </div>
          {/* Totals skeleton */}
          <div className='space-y-2 pt-4'>
            <div className='ml-auto h-5 w-48 rounded bg-muted' />
            <div className='ml-auto h-5 w-48 rounded bg-muted' />
            <div className='ml-auto h-6 w-48 rounded bg-muted' />
          </div>
        </div>

        {/* Customer details skeleton */}
        <div className='space-y-4'>
          <div className='h-7 w-48 rounded bg-muted' />
          <div className='grid gap-6 md:grid-cols-2'>
            <div className='space-y-3'>
              <div className='h-6 w-40 rounded bg-muted' />
              <div className='space-y-2'>
                <div className='h-4 w-full rounded bg-muted' />
                <div className='h-4 w-full rounded bg-muted' />
                <div className='h-4 w-3/4 rounded bg-muted' />
              </div>
            </div>
            <div className='space-y-3'>
              <div className='h-6 w-40 rounded bg-muted' />
              <div className='space-y-2'>
                <div className='h-4 w-full rounded bg-muted' />
                <div className='h-4 w-full rounded bg-muted' />
                <div className='h-4 w-3/4 rounded bg-muted' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
